import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import KoochiLogo from '../../../../inc/assets/images/logo/koochi-logo.png';
import { handleChangeInputLoginPage, handleChangeProfileData, handleChangeToken } from '../../../../redux/actions/pages/user/login';
import { handleChangeTimerTimePageVerification, handleChangeInputVerificationPage } from "../../../../redux/actions/pages/user/verification";
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { LOGIN_POST, GET_CAPTCHA_IMAGE } from '../../../../apis'; 
import apiRequest from '../../../../utils/apiRequest';
import ReCAPTCHA from "react-google-recaptcha";

const Login = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [captchaValue, setCaptchaValue] = useState(null);

	const { mobile, password, disabledBtn, captchaImage, captcha } = useSelector(state => state.login);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);

	useEffect(() => {
        // apiGetCaptcha();
        // eslint-disable-next-line
    }, [Login]); 


    const handleChangeInputMobilePageLogin = (event) => {
        const {name, value} = typeof event === 'string' ? {name: "mobile", value: event} : event.target;
        dispatch(handleChangeInputLoginPage(name, changeNumberPersianAndArabic(value)));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }


    const handleChangeInputPageLogin = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeInputLoginPage(name, value));
    };

    const apiGetCaptcha = () => {
    	if(! isBackdropLoading) {
    		apiRequest({
			    dispatch,
			    endpoint: GET_CAPTCHA_IMAGE,
			    method: 'post',
			    data: { mobile },
			    token: null,
			    successMessage: null,
			    onSuccess: (res) => {
			      	dispatch(handleChangeInputLoginPage('captchaImage', res.image));
			    },
		  	});
    	}
    }


    const handleSubmitFormLogin = (event) => {
    	event.preventDefault();

    	if(! isBackdropLoading) {
    		if(mobile.length !== 11)
	    		dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل باید 11 رقم باشد', severity: 'error', vertical: 'top', horizontal: 'right'}));
	    	// else if(password.length === 0)
	    	// 	dispatch(handleSetOpenCustomSnackbar(true, {message: 'رمز عبور را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
	    	// else if(! captchaValue)
	    	// 	dispatch(handleSetOpenCustomSnackbar(true, {message: 'لطفا تایید کنید که ربات نیستید', severity: 'error', vertical: 'top', horizontal: 'right'}));
	    	else {
	    		apiRequest({
				    dispatch,
				    endpoint: LOGIN_POST,
				    method: 'post',
				    data: { mobile },
				    onSuccess: (res) => {
				      	dispatch(handleChangeTimerTimePageVerification(parseInt(res.timer_time)));
	                    dispatch(handleChangeInputVerificationPage('inputClass', 'Input-InputWrapper-d'));
    					dispatch(handleChangeInputVerificationPage('errorTxt', ''));
    					dispatch(handleChangeInputVerificationPage('code', ''));
	                    navigate(`verify`);
				    },
			  	});
	    	}
    	}

    };

    const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};


    return (


		<div className="app-content  container-fluid">
  			<div className="content-wrapper">
    			<div className="content-header row">
    			</div>
    			<div className="content-body">
    				<section className="flexbox-container">
						<div className="col-md-6 col-lg-4 offset-md-3 offset-lg-4 col-xs-12 offset-xs-0  box-shadow-2 p-0">
    						<div className="card border-grey border-lighten-3 m-0" style={{minHeight: 'unset !important'}} >
        						<div className="card-header no-border">
            						<div className="card-title text-xs-center">
                						<div className="p-1">
                							<img src={KoochiLogo} alt="branding logo" width="150" />
                						</div>
        							</div>
        							<h6 className="card-subtitle line-on-side text-muted text-xs-center font-small-3 pt-2"><span>صفحه ورود به پنل فروشنده</span></h6>
        							<h6 className="card-subtitle text-muted text-xs-center font-small-3 pt-2"><span>تماس با پشتیبانی: <a href="tel:+989391019323" style={{color: '#0100fe'}}>{toPersianDigits("9323 101 0939")}</a></span></h6>
    							</div>
        						<div className="card-body collapse in">
            						<div className="card-block">
            							<form className="form-horizontal form-simple" onSubmit={handleSubmitFormLogin}>
					                        <fieldset className="form-group position-relative has-icon-left ">
					                            <input type="text" name="mobile" value={mobile} onChange={handleChangeInputMobilePageLogin} className="form-control form-control-lg input-lg" id="user-name" placeholder="موبایل" />
					                            <div className="form-control-position" style={{display: 'flex', alignItems: 'center'}}>
					                                <i className="icon-head" style={{top: 'unset'}}></i>
					                            </div>
					                        </fieldset>
					                        {/*<fieldset className="form-group position-relative has-icon-left">
					                            <input type="password" name="password" value={password} onChange={handleChangeInputPageLogin} className="form-control form-control-lg input-lg" id="user-password" placeholder="رمز عبور" />
					                            <div className="form-control-position">
					                                <i className="icon-key3"></i>
					                            </div>
					                        </fieldset>*/}
					                        {/*<fieldset className="form-group row">
					                            <div className="col-md-6 col-xs-12 text-xs-center text-md-left">
					                                <fieldset>
					                                    <input type="checkbox" name="remember" id="remember-me" className="chk-remember" />
					                                    <label htmlFor="remember-me"> مرا به خاطر بسپار!</label>
					                                </fieldset>
					                            </div>

					                        </fieldset>*/}

					                        {/*<fieldset className="form-group row">
					                            <div className="col-md-6 col-xs-12 text-xs-center text-md-left">
					                              	<fieldset>
					                              		<ReCAPTCHA
													        sitekey="6Lcy3pwUAAAAAJrXbSGF0WB_4UrF_ktGoc5hSSnV"
													        onChange={(value) => setCaptchaValue(value)} />
					                                  	<br/>
					                              	</fieldset>
					                            </div>
				                            </fieldset> */}

				                            {/*<fieldset className="form-group position-relative has-icon-left">
					                            <input type="text" name="captcha" onChange={handleChangeInputPageLogin} className="form-control form-control-lg input-lg" id="captcha" placeholder="متن تصویر" maxlength="4" />
					                            <br />
					                            <div style={{display: 'flex', alignItems: 'center'}}>
					                            	<div dangerouslySetInnerHTML={{ __html: captchaImage }} />

					                                <i onClick={apiGetCaptcha} className="icon-android-refresh mx-2 refresh-captcha" title="بارگزاری مجدد" style={{cursor: 'pointer', fontSize: '17px'}}></i>
					                            </div>
					                        </fieldset>*/}

	                    					<button type="submit" name="register_btn" value="login" disabled={disabledBtn} className="btn btn-primary btn-lg btn-block"><i className="icon-unlock2"></i> ورود</button>
                						</form>
            						</div>
        						</div>
					            <div className="card-footer">
					                <div className="">
					                    {/*<p className="float-sm-left text-xs-center m-0"><a href="recover-password.html" className="card-link">رمز عبورم را فراموش کرده ام.</a></p>*/}
					                </div>
					            </div>
    						</div>
						</div>
					</section>

    			</div>
  			</div>
		</div>



    );
}

export default Login;